/*
 * Copyright 2020 Drivetrain Hub LLC
 * Functions for spur and helical gear mesh equations.
 * Counterpart to dh-gear mesh module.
 */

import gear from "./gear";

// region PRESSURE ANGLES

function workingPressureAngleTransverse1(workingCenterDistance, baseDiameter1, baseDiameter2) {
  return Math.acos((baseDiameter1 + baseDiameter2) / (2 * workingCenterDistance));
}

function workingPressureAngleTransverseTheoretical1({x1, x2, z1, z2, alphaN, alphaT}) {
  // x: profile shift coefficient, z: number of teeth, alpha: pressure angle

  const invAlphaW = gear.involuteFcn(alphaT) + 2 * Math.tan(alphaN) * (x1 + x2) / (z1 + z2);

  if (invAlphaW >= 0) {
    return gear.inverseInvoluteFcn(invAlphaW);
  }
}

function pressureAngleTransverseContactPoint1(
  workingPressureAngleTransverse, numberOfTeeth, matingNumberOfTeeth, matingPressureAngleTransverseContactPoint) {
  const tanAlphaW = Math.tan(workingPressureAngleTransverse);
  const z = numberOfTeeth;
  const zMate = matingNumberOfTeeth;
  const tanAlphaContactMate = Math.tan(matingPressureAngleTransverseContactPoint);

  return Math.atan(tanAlphaW - zMate / z * (tanAlphaContactMate - tanAlphaW))
}

// endregion

// region CENTER DISTANCE

function centerDistanceReference2({moduleTransverse, z1, z2}) {
  return moduleTransverse * (z1 + z2) / 2;
}

function centerDistanceTheoretical1({referenceCenterDistance, workingPressureAngleTransverse, pressureAngleTransverse}) {
  return referenceCenterDistance * Math.cos(pressureAngleTransverse) / Math.cos(workingPressureAngleTransverse);
}

// endregion

// region BACKLASH

function backlashRadial1(centerDistanceWorking, centerDistanceTheoretical) {
  return centerDistanceWorking - centerDistanceTheoretical;
}

function backlashCircumferential1(backlashRadial, workingPressureAngleTransverse) {
  return 2 * backlashRadial * Math.tan(workingPressureAngleTransverse);
}

function backlashProfile1(backlashCircumferential, workingPressureAngleTransverse) {
  return backlashCircumferential * Math.cos(workingPressureAngleTransverse);
}

// endregion

// region SLIDING

function slidingContactPointSpeed1(baseDiameter, pressureAngleTransverseAtContactPoint, angularVelocity) {
  // Tooth contact point velocity in the direction of sliding.
  // Sign convention is not considered, with absolute values taken for base diameter and angular velocity.

  return Math.abs(baseDiameter) * Math.tan(pressureAngleTransverseAtContactPoint) * Math.abs(angularVelocity) / 2;
}

function slidingVelocity1(u1, u2) {
  // Sliding velocity of gear 1 relative to gear 2.
  return u1 - u2;
}

function specificSliding1(slidingVelocity, slidingContactPointSpeed) {
  return slidingVelocity / slidingContactPointSpeed;
}

function angularVelocityOutput1(angularVelocityInput, gearRatio) {
  // Assumes gear mesh ratio is (+) for an external gear mesh and (-) for an internal gear mesh.
  return - angularVelocityInput / gearRatio;
}

// endregion

// region ANALYSIS

// endregion

export default {
  workingPressureAngleTransverse1: workingPressureAngleTransverse1,
  workingPressureAngleTransverseTheoretical1: workingPressureAngleTransverseTheoretical1,
  pressureAngleTransverseContactPoint1: pressureAngleTransverseContactPoint1,
  // CENTER DISTANCE
  centerDistanceReference2: centerDistanceReference2,
  centerDistanceTheoretical1: centerDistanceTheoretical1,
  // BACKLASH
  backlashRadial1: backlashRadial1,
  backlashCircumferential1: backlashCircumferential1,
  backlashProfile1: backlashProfile1,
  // SLIDING
  slidingContactPointSpeed1: slidingContactPointSpeed1,
  slidingVelocity1: slidingVelocity1,
  specificSliding1: specificSliding1,
  angularVelocityOutput1: angularVelocityOutput1,
}
